import { http } from '../../../../config/HttpCommon';

export const getEventsById = async (userId: string, nodeId: string, dtStartTime: string, dtEndTime: string) => {
  const response = await http.get(`/getAssetEvents?userId=${userId}&nodeId=${encodeURIComponent(nodeId)}&dtStartTime=${dtStartTime}&dtEndTime=${dtEndTime}`);
  return response.data;
};